// extracted by mini-css-extract-plugin
module.exports = {"naviContainer":"Navi_11K5SpJA2B"};